/**
 * Simple tabs which use display block/none to show/hide immediate children
 */
export class Tabs {

    /**
     * Creates a new instance of the constructor.
     *
     * @param {HTMLElement} el - The element to be used for creating the instance.
     * @param {number} initialVisible - The initial visibility value for the instance (default is 0).
     * @return {void}
     */
    constructor(el, initialVisible = 0) {
        this.el = el;
        this.children = Array.from(el.children);

        this.show(initialVisible);
    }

    /**
     * Shows tab at index
     * @param n
     */
    show(n) {
        this.current = n;
        this.children.forEach((child, i) => {
            child.style.display = i === n ? "block" : "none";
        });
    }

    hide(n) {
        if (this.children[n]) {
            this.children[n].style.display = "none";
        }
    }
}
